import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Bounce } from 'react-reveal';
import { NavLink, useParams } from 'react-router-dom';
import { Button, Icon, List } from 'semantic-ui-react';
import GConf from '../../AssetsM/generalConf';
import BreadCrumb from '../Assets/breadCrumb'
import SKLT from '../../AssetsM/usedSlk';
import { toast } from 'react-toastify';
import usePrintFunction from '../Assets/Hooks/printFunction';
import FrameForPrint from '../Assets/frameForPrint';
import { BottomSheet } from 'react-spring-bottom-sheet'
import 'react-spring-bottom-sheet/dist/style.css'

function RequestInfo() {
    /*#########################[Const]##################################*/
    const {CID} = useParams()
    const [articleL, setArticleL] = useState([])
    const [commandeData, setCommandeD] = useState([])
    const [facturerData, setFacturerD] = useState([])
    const [loading , setLoading] = useState(false)
    const [btnState, setBtnState] = useState(false)
    const [printLink, setPrintLink] = useState(`/Pr/commande/${CID}`)
    let [open, setOpen] = useState(false)

    /*#########################[useEffect]##################################*/ 
    useEffect(() => {
        axios.post(`${GConf.ApiLink}/commande/info`, {
            PID : GConf.PID,
            CID: CID
          })
          .then(function (response) {
                if (!response.data[0]) {
                    toast.error('Commande Introuvable !', GConf.TostSuucessGonf)
                    setTimeout(() => {  window.location.href = "/S/rq"; }, 2000)
                } else {
                    
                    setCommandeD(response.data[0])
                    setLoading(true)  
                    setFacturerD({client: response.data[0].Client, de:'Sidi Bourouis', vers: response.data[0].Adress, jour: response.data[0].Date_Volu, totale: response.data[0].Totale , articles:JSON.parse(response.data[0].Articles)})    
                    if(response.data[0].State != 'W' && response.data[0].State != 'S'){setBtnState(true)}
                    if(response.data[0].State == 'W' ){UpdateState('S') }
                    
                    if(response.data[0].Articles != '' ){ setArticleL(JSON.parse(response.data[0].Articles)) }
                    
                }  
          }).catch((error) => {
            if(error.request) {
              toast.error(<><div><h5>Probleme de Connextion</h5> Impossible de charger la commande   </div></>, GConf.TostInternetGonf)   
              
            }
          });
    }, [])

    /*#########################[Functions]##################################*/
    const PrintFunction = (frameId) =>{ usePrintFunction(frameId) }
    const UpdateState = (stateBtn) =>{
        axios.post(`${GConf.ApiLink}/commande/controle`, {
            PID : GConf.PID,
            RID: CID,
            state: stateBtn
          })
          .then(function (response) {
            setCommandeD({ ...commandeData, State: stateBtn}) 
            if(stateBtn != 'S'){setBtnState(true)}            
          }).catch((error) => {
            if(error.request) {
              toast.error(<><div><h5>Probleme de Connextion</h5> Impossible de modifier L'etat du commande  </div></>, GConf.TostInternetGonf)   
              setBtnState(true)
            }
          });
    }
    const FacturerCommande = () =>{
        axios.post(`${GConf.ApiLink}/facture/ajouter`, {
            PID : GConf.PID,
            factD: facturerData,
        })
        .then(function (response) { 
            if(response.status = 200) {
                UpdateState('A')
                toast.success("Factureé !", GConf.TostSuucessGonf)
                setBtnState(true)
            }
            else{
                toast.error('Erreur esseyez de nouveaux', GConf.TostSuucessGonf)
            }           
        }).catch((error) => {
            if(error.request) {
              toast.error(<><div><h5>Probleme de Connextion</h5> Impossible de Facturer la commande  </div></>, GConf.TostInternetGonf)   
              setBtnState(true)
            }
          });
        
    }
    
    const DeleteReservation = () =>{
        axios.post(`${GConf.ApiLink}/reversation/supprimer`, {
            R_ID : CID,
           
        })
        .then(function (response) { 
               setTimeout(() => {  window.location.href = "/S/rq"; }, 1000)     
        }).catch((error) => {
            if(error.request) {
              toast.error(<><div><h5>Probleme de Connextion</h5> Impossible de Facturer la commande  </div></>, GConf.TostInternetGonf)   
              setBtnState(true)
            }
          });
        
    }

    /*#########################[Card]##################################*/
    const StateCard = ({ status }) => {
        const StateCard = (props) =>{ return <span className={`badge bg-${props.color}`}> {props.text} </span>}
        const statusCard = React.useCallback(() => {
          switch(status) {
            case 'W': return <StateCard color='warning' text='En Attent' />;  
            case 'S': return <StateCard color='info' text='Vu' />;  
            case 'A': return <StateCard color='success' text='Acepteé' /> ;
            case 'R': return <StateCard color='danger' text='Refuseé' />;
            default:  return <StateCard color='secondary' text='Indefinie' />;    
          }
        }, [status]);
      
        return (
          <div className=" ">
            {statusCard()}
          </div>
        );
    };
    const StateGenreCard = ({ status }) => {
            const StateCard = (props) =>{ return <span className={`badge bg-${props.color}`}> <h2> {props.text} </h2> </span>}
            const statusCard = React.useCallback(() => {
              switch(status) {
                case 'OUVERT': return <StateCard color='ouvert' text=' القاعة العادية' />;  
                case 'COUVERT': return <StateCard color='couvert' text=' القاعة المغطاة' />;  
                case 'DYNAMIQUE': return <StateCard color='dynamique' text=' القاعة المتنقلة' /> ;
                default:  return <StateCard color='secondary' text='Indefinie' />;    
              }
            }, [status]);
          
            return (
              <div className="container">
                {statusCard()}
              </div>
            );
        };
    const CommentaireCard = () =>{
        return(<>
                <div className='card card-body shadow-sm mb-2 mt-3 border-div'>
                      
                </div>
        </>)
    }
    const BtnsCard = () =>{
        return(<>
                <div className='card card-body shadow-sm mb-2 border-div'>
                    <h5>Controle</h5>
                    <div className='row mb-2'>
                        <div className='col-6'>
                            <Button  className='rounded-pill bg-danger text-white'  fluid onClick={ () => UpdateState('R')}><Icon name='edit outline' /> Anuulée</Button>
                        </div>
                        <div className='col-6'>
                            <Button  className='rounded-pill bg-success text-white'  fluid onClick={ () => UpdateState('A')}><Icon name='edit outline' /> ACCEPTER </Button>
                        </div>
                         
                    </div>
                    <div className='row mb-2'>
                        <div className='col-12'>
                            <Button  className='rounded-pill bg-warning text-white'  fluid onClick={ () => UpdateState('W')} ><Icon name='calendar' /> marquer comme En Attent  </Button>
                        </div>
                    </div>
                    <hr />
                    <div className='row mb-2'>
                        <div className='col-12 mb-2'>
                            <Button  className='rounded-pill bg-secondary text-white'  fluid onClick={ () => alert('W')} ><Icon name='edit' /> Modifier   </Button>
                        </div>
                        <div className='col-12'>
                            <Button  className='rounded-pill bg-danger text-white'  fluid onClick={ () => setOpen(!open)} ><Icon name='trash' /> Supprimer   </Button>
                        </div>
                    </div>
                    <hr />
                     <div className='row mb-2'>
                        <div className='col-12 mb-2'>
                            <Button  className='rounded-pill bg-info  text-white'  fluid onClick={(e) => PrintFunction('printFacture')} ><Icon name='calendar' /> طباعة عقد قاعة متنقلة  </Button>
                        </div>
                        <div className='col-12'>
                            <Button  className='rounded-pill bg-info  text-white'  fluid onClick={(e) => PrintFunction('printFacture')} ><Icon name='calendar' />  طباعة عقد قاعة عادية   </Button>
                        </div>
                    </div>
                </div>
        </>)
    }
    const CommandeHeader = () =>{
        return(<>
                
                <br />
                <div className='row'>
                    <div className='col-6 mb-4'>
                        <h3 className='text-start mb-4'>Info de Client </h3> 
                        {/* <div className='text-secondary'><b>CODE RESERVATIONS : </b> {CID}</div> */}
                        <div className='text-secondary'><b>Nom : </b> {loading ?  commandeData.Client_Name  : SKLT.BarreSkl } </div>
                        <div className='text-secondary'><b>Telephone : </b> {loading ?  commandeData.Client_Phone  : SKLT.BarreSkl } </div>
                        <div className='text-secondary'><b>Carte Cin : </b> {loading ?  commandeData.Client_CIN  : SKLT.BarreSkl } </div>
                        {/* <div className='text-secondary'><b>Adresse : </b> {loading ?  commandeData.Client_Adresse  : SKLT.BarreSkl } </div> */}
                    </div>
                    <div className='col-6 mb-4'>
                        <h3 className='text-start mb-4'>Info de Reservation </h3> 
                        <div className='text-secondary'><b>Date  : </b> {loading ? new Date(commandeData.Date_Volu).toLocaleDateString('fr-FR').split( '/' ).reverse( ).join( '-' )  : SKLT.BarreSkl } </div>
                        <div className='text-secondary'><b>Reservation à la salle   : </b> {loading ? <StateGenreCard status={commandeData.Salle_Genre} /> : SKLT.BarreSkl } </div>
                        {/* <div className='text-secondary'><b>Passé Le  : </b> {loading ?  new Date(commandeData.Date_Passe).toLocaleDateString('fr-FR').split( '/' ).reverse( ).join( '-' ) : SKLT.BarreSkl } </div> */}
                        {/* <div className='text-secondary'><b>Estimation de Présence : </b> {loading ? commandeData.Estimation_Pr : SKLT.BarreSkl } personne  </div> */}
                    </div>
                    <h5> </h5>
                    <h3 className='text-start mb-4'>Commentaires </h3>
                    <span>{loading ? commandeData.Comments : SKLT.BarreSkl }</span>

                    <h3 className='text-start mt-4 mb-4'> Liste des Fournitures :  </h3>
                    <ul className='ps-4'>
                         {articleL.map((data,index) => <li className='ms-5'>{data.qte} x {data.Name}</li>)}
                    </ul>
                </div>
        </>)
    }
    
    return ( <> 
        <BreadCrumb links={GConf.BreadCrumb.RequestInfo} />
        <br />
        <div className="row">
            <div className="col-12 col-lg-8">
                <h2 className='text-start'><StateCard status={commandeData.State} /></h2>
                <CommandeHeader />
                <br />
                <br />
                 
            </div>
            
            <div className="col-12 col-lg-4">
            <Bounce bottom>
                <BtnsCard />
            </Bounce>
            </div>
        </div>
        <FrameForPrint frameId='framed' src={printLink} />
        <FrameForPrint frameId='printFacture' src={`/Pr/contrat/${CID}`} />
        <BottomSheet style={{ '--rsbs-max-w': '50vw',  '--rsbs-ml': 'auto', '--rsbs-mr': 'auto' }}  expandOnContentDrag open={open}  onDismiss={() => setOpen(!open)}  >
            <div className="card-body">
                <h5>Voulez vous vraiment supprimer cette Reservation ! </h5>
                <div className='text-center'>
                    <Button  className='rounded-pill bg-danger text-white'  fluid onClick={ () => DeleteReservation(!open)} ><Icon name='trash' /> Supprimer   </Button>
                </div>
            </div>     
        </BottomSheet>
    </> );
}

export default RequestInfo;